import React, { useEffect, useState } from 'react';
import "../../Category.css";
import { Link } from 'react-router-dom';
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { BrowserView, MobileView } from 'react-device-detect';

const Category = () => {
    const [loading, setLoading] = useState(false);
    const [category, setCategory] = useState([]);

    useEffect(() => {
        const fetchtcategory = async () => {
            try {
                setLoading(true);
                const categoryData = await ApiService.Commanfetchrequest('categories');
                setCategory(categoryData);
                // console.log('category data:', categoryData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchtcategory();
    }, []);

    return (
        <>
            <BrowserView>
                <div className="category-container">
                    {loading
                        ? Array.from({ length: 10 }).map((_, index) => (
                            <div key={index} className="category-item">
                                <Skeleton
                                    circle={true}
                                    width={40}
                                    height={40}
                                    style={{ marginBottom: '10px' }}
                                />
                                <span><Skeleton width={80} height={20} /></span>
                            </div>
                        ))
                        : category.map((cat, index) => (
                            <Link key={index} to={`/category/${cat.url}`} style={{ textDecoration: "none" }}>
                                <div className="category-item">
                                    {cat.category_image && (
                                        <img
                                            src={`https://www.adminfamilyfun.jewelscraze.com/front/images/categories/${cat.category_image}`}
                                            alt={cat.category_name}
                                            className="category-image"
                                            style={{ width: "30px", height: "30px" }}
                                            loading="lazy"
                                        />
                                    )}
                                    <br />
                                    <span>{cat.category_name}</span>
                                </div>
                            </Link>
                        ))}
                </div>
            </BrowserView>
            <MobileView>
                <div className="category-container">
                    {loading
                        ? Array.from({ length: 6 }).map((_, index) => (
                            <div key={index} className="category-item">
                                <Skeleton
                                    circle={true}
                                    width={40}
                                    height={40}
                                    style={{ marginBottom: '10px' }}
                                />
                                <span><Skeleton width={80} height={20} /></span>
                            </div>
                        ))
                        : category.map((cat, index) => (
                            <Link key={index} to={`/category/${cat.url}`} style={{ textDecoration: "none" }}>
                                <div className="category-item">
                                    {cat.category_image && (
                                        <img
                                            src={`https://www.adminfamilyfun.jewelscraze.com/front/images/categories/${cat.category_image}`}
                                            alt={cat.category_name}
                                            className="category-image"
                                            style={{ width: "30px", height: "30px" }}
                                            loading="lazy"
                                        />
                                    )}
                                    <br />
                                    <span>{cat.category_name}</span>
                                </div>
                            </Link>
                        ))}
                </div>
            </MobileView>

        </>
    );
};

export default Category;
